import React, { createContext, useContext } from 'react';

// Context to track if Shell is already rendered
const ShellContext = createContext(false);

// Hook to check if we're inside a Shell
export const useIsInsideShell = () => useContext(ShellContext);

// Provider to mark that Shell is rendered
export const ShellProvider = ({ children }) => (
  <ShellContext.Provider value={true}>
    {children}
  </ShellContext.Provider>
);

export default ShellContext;
